import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import Bookings from "./Bookings";
import { getUserProjects } from "../../../redux/actions/projectsAction";

const CustomerDashboard = () => {
  const [data, setData] = useState([]);

  const getData = () => {
    getUserProjects().then((res) => {
      if (res.status) {
        setData(res.data);
      }
    });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Dashboard</h3>
        </Col>
      </Row>
      <Row>
        {/* <ExampleCard /> */}
        {data.length ? (
          data.map((dat, key) => {
            return <Bookings key={key} projectInfo={dat} />;
          })
        ) : (
          <div> No Projects found</div>
        )}
      </Row>
    </Container>
  );
};

export default CustomerDashboard;
